import { isBefore, subHours } from 'date-fns';

export const isDateWithinIntervalOfAnotherDate = (
  date1: Date,
  date2: Date,
  intervalHours: number,
): boolean => {
  return isBefore(subHours(date1, intervalHours), date2);
};
